import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Typography } from "antd";
import { Icon, SvgIcon } from "assets/icons";
import CustomTable from "components/CustomTable";
import { TabsMenu } from "components/CustomTabs";
import FormInput from "components/FormInput";
import { PrimaryButton, PrimaryButtonOutLine } from "components/PrimaryButton";
import { INPUT_TYPE } from "config/constants";
import { t } from "i18next";
import { CircleHelp } from "lucide-react";
import { AgentShowModal } from "./components/AgentShowModal";
import { ProductShowModal } from "./components/ProductShowModal";
import "./index.scss";
import useInfoVoucher from "./useInfoVoucher";

const InfoVoucher = ({ campaignData }) => {
  const {
    loading,
    paginationData,
    columns,
    data,
    handleSearchVoucher,
    activeTab,
    handleChangeTab,
    handleChangeTable,
    confirmModalConfig,
    renderTagsList,
    renderTagUsedQuantity,
    agentModalConfig,
    productModalConfig,
    dataCount,
  } = useInfoVoucher({ promotionCampaignIDs: campaignData?.id });

  const tabs = [
    {
      title: (
        <div className="title">
          {t("warehouse.recommendImport.all")} ({dataCount.ALL || 0})
        </div>
      ),
      key: "ALL",
    },
    {
      title: <div className="title">Sắp diễn ra ({dataCount.UPCOMING || 0})</div>,
      key: "UPCOMING",
    },
    {
      title: <div className="title">Có hiệu lực ({dataCount.ONGOING || 0})</div>,
      key: "ONGOING",
    },
    {
      title: <div className="title">Hết hiệu lực ({dataCount.EXPIRED || 0})</div>,
      key: "EXPIRED",
    },
    {
      title: <div className="title">Hết lượt sử dụng ({dataCount.OUT_OF_USAGE || 0})</div>,
      key: "OUT_OF_USAGE",
    },
    {
      title: <div className="title">Đã vô hiệu ({dataCount.DISABLE || 0})</div>,
      key: "DISABLE",
    },
  ];

  // Lấy text trạng thái hiện tại của voucher
  const getStatusText = (status) => {
    const statusMap = {
      UPCOMING: "Sắp diễn ra",
      ONGOING: "Có hiệu lực",
      EXPIRED: "Hết hiệu lực",
      OUT_OF_USAGE: "Hết lượt sử dụng",
      DISABLE: "Đã vô hiệu",
    };
    return statusMap[status] || status;
  };

  return (
    <div className="info-voucher">
      <TabsMenu defaultActiveKey={activeTab} tabs={tabs} onChange={handleChangeTab} />

      <div className="search-input">
        <FormInput
          {...{
            type: INPUT_TYPE,
            inputOptions: {
              onChange: handleSearchVoucher,
              placeholder: "Tìm kiếm theo mã voucher",
              prefix: <FontAwesomeIcon icon={Icon.faSearch} />,
            },
          }}
        ></FormInput>
      </div>
      <div style={{ margin: "12px 0", display: "flex", flexWrap: "wrap" }}>
        {activeTab === "ALL" && renderTagsList}
        {renderTagUsedQuantity()}
      </div>
      <div className="table-list-recommend-import">
        <CustomTable
          rowKey={(record) => record?.id}
          loading={loading}
          columns={columns}
          dataSource={data}
          scroll={{ x: "2500px", y: null }}
          onChange={handleChangeTable}
          pagination={{
            total: paginationData?.total ?? 0,
            pageSize: paginationData?.limit,
            current: paginationData?.offset / paginationData?.limit + 1 || 1,
            showSizeChanger: false,
          }}
        />
      </div>

      {/* Modal xác nhận kích hoạt/vô hiệu hóa voucher */}
      <Modal
        visible={confirmModalConfig.visible}
        onCancel={confirmModalConfig.onCancel}
        footer={null}
        centered
        width={450}
        className="confirm-voucher-modal"
      >
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          <SvgIcon.IconInfoQuestion
            style={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              backgroundColor: "#EBF0FF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
            }}
          />

          <Typography.Text style={{ fontSize: 14 }}>
            {confirmModalConfig.action === "ACTIVATE"
              ? "Bạn chắc chắn muốn kích hoạt mã voucher"
              : "Bạn chắc chắn muốn vô hiệu hoá mã voucher"}
          </Typography.Text>
          <Typography.Text strong style={{ fontSize: 14, color: "#2246DC" }}>
            &nbsp;{confirmModalConfig.voucher?.code}&nbsp;
          </Typography.Text>
          <Typography.Text style={{ fontSize: 14 }}>không?</Typography.Text>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              justifyContent: "center",
              marginTop: 16,
              marginBottom: 24,
              color: "#5B6673",
            }}
          >
            <CircleHelp size={24} color="#00000073" strokeWidth={1.2} />
            <Typography.Text type="secondary" style={{ fontSize: 12, display: "block" }}>
              {confirmModalConfig.action === "ACTIVATE"
                ? "Lưu ý: Sau khi xác nhận, đại lý có thể xem và áp dụng ưu đãi!"
                : `Lưu ý: Sau khi xác nhận, hệ thống sẽ chuyển trạng thái của mã voucher từ ${getStatusText(confirmModalConfig.voucher?.status)} sang Đã vô hiệu!`}
            </Typography.Text>
          </div>

          <div style={{ display: "flex", gap: 16, justifyContent: "center" }}>
            <PrimaryButtonOutLine
              title="Hủy bỏ"
              onClick={confirmModalConfig.onCancel}
              style={{ minWidth: 100, height: 36 }}
              disabled={confirmModalConfig.loading}
            />
            <PrimaryButton
              title="Xác nhận"
              onClick={confirmModalConfig.onConfirm}
              style={{ minWidth: 100, height: 36 }}
              loading={confirmModalConfig.loading}
            />
          </div>
        </div>
      </Modal>

      {/* Modal xem chi tiết đại lý */}
      <AgentShowModal
        visible={agentModalConfig.visible}
        onCancel={agentModalConfig.onClose}
        voucherID={agentModalConfig.voucherID}
      />

      {/* Modal xem chi tiết sản phẩm */}
      <ProductShowModal
        visible={productModalConfig.visible}
        onCancel={productModalConfig.onClose}
        voucherID={productModalConfig.voucherID}
      />
    </div>
  );
};

export default InfoVoucher;
